import styled from '@emotion/styled';
import { css, Grid, Typography } from '@mui/material';
import { colors } from 'theme/colors';

interface IImportImageContainer {
  disabled?: boolean;
  hasError?: boolean;
}
export const ImportImageContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'hasError',
})<IImportImageContainer>`
  width: 100%;
  min-height: 132px;
  flex: 1 1 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 12px;
  padding: 24px;
  border: 1px solid ${colors.gray400};
  border-style: dashed;
  border-radius: 4px;
  &:hover {
    border-color: ${colors.primary400};
    background: ${colors.primary15};
  }
  ${(props: IImportImageContainer) =>
    props.disabled &&
    css`
      border-color: ${colors.gray300};
      background: ${colors.gray50};
      & .MuiTypography-root {
        color: ${colors.gray300};
      }
    `}
  ${(props: IImportImageContainer) =>
    props.hasError &&
    css`
      border-color: ${colors.error600};
      &:hover {
        border-color: ${colors.error600};
      }
    `}
`;

export const StyledUploadedFiles = styled(Typography)`
  color: ${colors.primary900};
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 4px;
  background-color: ${colors.primary15};
  padding: 13px 24px;
`;
